import { FC } from 'react';

import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';
import { ExclamationTriangleFilledSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    title: 'CampaignCreationWizardFlow.backAlert.title',
    description: 'CampaignCreationWizardFlow.backAlert.description',
    confirm: 'CampaignCreationWizardFlow.backAlert.confirm',
    cancel: 'CampaignCreationWizardFlow.backAlert.cancel',
};

interface CampaignCreationWizardBackAlertProps {
    visible: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const CampaignCreationWizardBackAlert: FC<CampaignCreationWizardBackAlertProps> = ({
    visible,
    onClose,
    onConfirm,
}) => {
    const trl = useTrls();

    return (
        <Alert
            visible={visible}
            onClose={onClose}
            title={trl(TrlKeys.title)}
            description={trl(TrlKeys.description)}
            buttons={
                <ButtonStack stretched layout="vertical">
                    <Button
                        mode="primary"
                        style="accent"
                        stretched
                        onClick={onConfirm}
                        data-qa="campaign-creation-wizard-back-confirm"
                    >
                        {trl(TrlKeys.confirm)}
                    </Button>
                    <Button
                        mode="secondary"
                        style="accent"
                        stretched
                        onClick={onClose}
                        data-qa="campaign-creation-wizard-back-cancel"
                    >
                        {trl(TrlKeys.cancel)}
                    </Button>
                </ButtonStack>
            }
            data-qa="campaign-creation-wizard-back-alert"
        >
            <ExclamationTriangleFilledSize24
                initialColor="warning"
                backgroundStyle="warning-secondary"
                padding={12}
                borderRadius="halfHeight"
            />
        </Alert>
    );
};
